export default /* html */`
<div class="container">
  <pre
    class="editor"
    *bind:theme="theme"
    *bind:contenteditable="contentEditable"
    spellcheck="false"
    tabindex="0"
    @beforeinput="handleBeforeinput"
    @focus="handleFocus"
    @focusout="handleFocusout"
    @cut="handleCut"
    @copy="handleCut"
    *ref="editor"
  ></pre>
</div>`